import { SELECIONAR_VIAGEM_VOLTA } from '../types';

export default function selecionarViagemIda (viagemVolta) {
  return {
    type: SELECIONAR_VIAGEM_VOLTA,
    payload: viagemVolta
  }
}
